<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<!-- <div class="form-floating col-md">
								<input type="date" class="form-control" name="received" [(ngModel)]="filters.received" id="received">
							<label for="received" class="form-label">Data wpływu (od:)</label>
							</div> -->
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="receivedFrom"
									[(ngModel)]="filters.received_from"
									id="receivedFrom"
								/>
								<label for="receivedFrom" class="form-label">Data wpływu (od:)</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="receivedTo"
									[(ngModel)]="filters.received_to"
									id="receivedTo"
								/>
								<label for="receivedTo" class="form-label">Data wpływu (do:)</label>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<label for="postSender" class="mt-3">Nadawca</label>
						<ng-select
							id="postSender"
							name="postSender"
							[(ngModel)]="filters.postSender"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of senders" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="recipient" class="mt-3">Odbiorca</label>
						<ng-select
							id="recipient"
							name="recipient"
							[(ngModel)]="filters.recipient"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							@for (company of companies; track company.id) {
								<ng-option [value]="company.id">{{ company.name }}</ng-option>
							}
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="givenTo" class="mt-3">Przekazano do</label>
						<ng-select
							id="givenTo"
							name="givenTo"
							[(ngModel)]="filters.givenToPerson"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="createdBy" class="mt-3">Utworzono przez</label>
						<ng-select
							id="createdBy"
							name="createdBy"
							[(ngModel)]="filters.createdBy"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							@for (user of users; track user.id) {
								<ng-option [value]="user.id">{{ user.name }}</ng-option>
							}
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="taskStatus" class="mt-3">Status</label>
						<ng-select
							id="taskStatus"
							name="taskStatus"
							[(ngModel)]="filters.taskStatus"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of taskStatuses" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
